/** Which cloud print backend a print house uses. Default / missing = PrintNode. */
export enum PrintProvider {
  PrintNode = "PrintNode",
  GoMakePrint = "GoMakePrint",
}

export const isGoMakePrintProvider = (provider?: string | null): boolean =>
  provider === PrintProvider.GoMakePrint;

export const resolvePrintProvider = (provider?: string | null): PrintProvider =>
  isGoMakePrintProvider(provider) ? PrintProvider.GoMakePrint : PrintProvider.PrintNode;
